import React from 'react';
import { TableCell, Box, TextField } from '@mui/material';
import { AdsTableFilters } from '../../../../types/ads.types';

interface MinMaxFilterCellProps {
  width?: number;
  minKey: keyof AdsTableFilters;
  maxKey: keyof AdsTableFilters;
  filters: AdsTableFilters;
  onFiltersChange: (filters: AdsTableFilters) => void;
  minPlaceholder?: string;
  maxPlaceholder?: string;
}

const inputSx = {
  '& .MuiInputBase-root': {
    fontSize: '0.75rem',
    bgcolor: 'white',
  },
  '& .MuiInputBase-input': {
    py: 0.5,
    px: 1,
  },
};

/**
 * MinMaxFilterCell - Reusable min/max numeric filter component
 * Used in FilterRow for filtering numeric metrics
 */
export const MinMaxFilterCell: React.FC<MinMaxFilterCellProps> = ({
  width = 75,
  minKey,
  maxKey,
  filters,
  onFiltersChange,
  minPlaceholder = 'Min',
  maxPlaceholder = 'Max',
}) => {
  const handleFilterChange = (key: keyof AdsTableFilters, value: unknown) => {
    onFiltersChange({
      ...filters,
      [key]: value,
    });
  };

  return (
    <TableCell sx={{ width, p: 0.5, bgcolor: '#fafafa' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <TextField
          size="small"
          placeholder={minPlaceholder}
          type="number"
          value={filters[minKey]}
          onChange={(e) => handleFilterChange(minKey, e.target.value)}
          sx={inputSx}
        />
        <TextField
          size="small"
          placeholder={maxPlaceholder}
          type="number"
          value={filters[maxKey]}
          onChange={(e) => handleFilterChange(maxKey, e.target.value)}
          sx={inputSx}
        />
      </Box>
    </TableCell>
  );
};
